export default "__VITE_PUBLIC_ASSET__fa74801c__"